import React, { FC } from 'react';

import styled from 'styled-components';
import EditFilledIcon from '@atlaskit/icon/glyph/edit-filled';
import { DEVELOPMENT } from 'util/Dev';

import { useSelector } from 'react-redux';

import { BotaoClean } from 'view/component/Botao/Botao';
import { SituacaoBotoesField } from 'view/component/Situacao/SituacaoBotoesField';
import { InteressadosBotaoPopup } from 'view/section/ServicoInteressados/Interessados';
import { useAutorizacao } from 'view/component/Autorizacao/useAutorizacao';
import { SolicitacaoServicoPageViewProps } from '../SolicitacaoServicoPage';

import { SolicitacaoCorrenteAction } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.action';
import { SolicitacaoCorrenteSelector } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.selector';
import { Situacao, Situacoes } from 'model/solicitacao/Situacao';
import { useUsuarioLogado } from 'view/component/UsuarioLogadoContext/UsuarioLogadoContext';
import { AvaliacaoBotao } from 'view/component/Avaliacao/AvaliacaoBotao';
import { useAppDispatch } from 'store/store';


interface SolicitacaoServicoPageBotoesAcoesProps extends SolicitacaoServicoPageViewProps {};

export const SolicitacaoServicoPageBotoesAcoes: FC<SolicitacaoServicoPageBotoesAcoesProps> = ({solicitacao}) => {
  const autorizacao = useAutorizacao();

  const usuarioLogado = useUsuarioLogado();
  
  const isCarregando = useSelector(SolicitacaoCorrenteSelector.formulario.isCarregando);
  const isVisualizar = useSelector(SolicitacaoCorrenteSelector.formulario.isVisualizar);
  const isNivel1 = autorizacao.papeis.Nivel1;

  const dispatch = useAppDispatch();

  const iniciarEdicao = () => dispatch(SolicitacaoCorrenteAction.edicao.iniciar());
  const atualizarSituacao = (situacao: Situacao) => dispatch(SolicitacaoCorrenteAction.edicao.atualizarSituacao(solicitacao, situacao)).unwrap();
  
  return <Acoes>
    { DEVELOPMENT && <InteressadosBotaoPopup isInteressado={true} /> }
    { isVisualizar && isNivel1 && <BotaoClean disabled={isCarregando} title="editar" onClick={iniciarEdicao}><EditFilledIcon label="editar" aria-hidden={true} /></BotaoClean>}
    { isVisualizar && <SituacaoBotoesField solicitacao={solicitacao} alterarSituacao={atualizarSituacao} />}
    { isVisualizar && solicitacao.situacao?.id===Situacoes.CONCLUIDO.id && solicitacao.idSolicitante === usuarioLogado.idInstitucional && <AvaliacaoBotao name="avaliacao" solicitacao={solicitacao} />}
  </Acoes>
}

const Acoes = styled.div`
  padding: .2rem 0;
  display: flex;
  align-items: center;
`;
